import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { FormControl } from '@angular/forms'

export enum RadioButtonOptions {
  YES = 'Yes',
  NO = 'No',
  BOTH = 'Both',
}

@Component({
  selector: 'hs-radio-group-filter',
  template: `
    <nf-form-control label="{{ label }}" compact="compact">
      <nf-radio-group [formControl]="radioFormControl">
        <nf-radio-button [value]="YES" [inline]="true"></nf-radio-button>
        <nf-radio-button [value]="NO" [inline]="true"></nf-radio-button>
        <nf-radio-button
          [value]="BOTH"
          [inline]="true"
          *ngIf="!excludeBoth"
        ></nf-radio-button>
      </nf-radio-group>
    </nf-form-control>
  `,
  styles: [':host{display:block}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioGroupFilterComponent {
  YES = RadioButtonOptions.YES
  NO = RadioButtonOptions.NO
  BOTH = RadioButtonOptions.BOTH

  @Input() radioFormControl!: FormControl
  @Input() label!: string
  @Input() excludeBoth = false
}
